
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Grid, Flex, Box, Image, AspectImage, Text, Link as A } from "theme-ui"
import { themes } from 'mdx-deck'
export const theme = { ...themes.prism
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Footer = makeShortcode("Footer");
const Steps = makeShortcode("Steps");
const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header mdxType="Header">
  <title>Git Presentation</title>
    </Header>
    <Footer mdxType="Footer">
  <Text sx={{
        color: 'gray',
        fontSize: 20,
        fontWeight: 'bold'
      }} mdxType="Text">Youth Code Jam &copy; 2020</Text>
    </Footer>
    <h1>{`git: Multiplayer Notepad`}</h1>
    <hr></hr>
    <h1>{`What is Git?`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul"><inlineCode parentName="li">{`git`}</inlineCode>{` is a VCS or version control system`}</li>
        <li parentName="ul">{`"its like Google Drive... but for code!"`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h1>{`maybe you've heard of `}<Text sx={{
        color: 'orange',
        textShadow: '0 0 12px currentColor',
        fontSize: 100,
        fontWeight: 'bold'
      }} mdxType="Text">{`Github`}</Text></h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul"><inlineCode parentName="li">{`Github`}</inlineCode>{` is a VCP or version control provider`}</li>
        <li parentName="ul">{`"it's the Drive part of Google Drive"`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <Box sx={{
      width: '75%'
    }} mdxType="Box">
      <h1>{`Let's `}<Text sx={{
          color: 'dodgerblue',
          textShadow: '0 0 12px currentColor',
          fontSize: 150,
          fontWeight: 'bold'
        }} mdxType="Text">{`Git`}</Text>{` Started!`}</h1>
    </Box>
    <hr></hr>
    <Box sx={{
      width: '75%'
    }} mdxType="Box">
      <h1>{`How to get `}<Text sx={{
          color: 'coral',
          textShadow: '0 0 12px currentColor',
          fontWeight: 'bold'
        }} mdxType="Text">{`help`}</Text>{` if you need it`}</h1>
      <Steps mdxType="Steps">
        <ul>
          <li parentName="ul"><inlineCode parentName="li">{`man git`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`git help`}</inlineCode></li>
          <li parentName="ul">{`StackOverflow`}</li>
        </ul>
      </Steps>
    </Box>
    <hr></hr>
    <Box sx={{
      width: '75%'
    }} mdxType="Box">
      <h1>{`The most `}<Text sx={{
          color: 'hotpink',
          textShadow: '0 0 12px currentColor',
          fontWeight: 'bold'
        }} mdxType="Text">{`important commands`}</Text>{` we will be learning:`}</h1>
      <Steps mdxType="Steps">
        <ul>
          <li parentName="ul"><inlineCode parentName="li">{`git remote`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`git add`}</inlineCode>{` and inversely, `}<inlineCode parentName="li">{`git rm`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`git commit`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`git push`}</inlineCode></li>
        </ul>
      </Steps>
    </Box>
    <hr></hr>
    <Box sx={{
      width: '75%'
    }} mdxType="Box">
      <h1>{`The not as important but still important `}<Text sx={{
          color: 'lightgreen',
          textShadow: '0 0 12px currentColor',
          fontWeight: 'bold'
        }} mdxType="Text">{`other commands`}</Text>{` we will be learning:`}</h1>
      <Steps mdxType="Steps">
        <ul>
          <li parentName="ul"><inlineCode parentName="li">{`git pull`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`git checkout`}</inlineCode></li>
        </ul>
      </Steps>
    </Box>
    <hr></hr>
    <Box sx={{
      width: '75%'
    }} mdxType="Box">
      <h1>{`Quite important `}<Text sx={{
          color: 'pink',
          textShadow: '0 0 12px currentColor',
          fontSize: 100,
          fontWeight: 'bold'
        }} mdxType="Text">{`Team Features`}</Text>{` we will be learning:`}</h1>
      <Steps mdxType="Steps">
        <ul>
          <li parentName="ul">{`PRs (Pull Requests)`}</li>
          <li parentName="ul">{`Issues`}</li>
          <li parentName="ul">{`effective commit messages`}</li>
          <li parentName="ul">{`Projects (optional)`}</li>
        </ul>
      </Steps>
    </Box>
    <hr></hr>
    <Box sx={{
      width: '75%'
    }} mdxType="Box">
      <h1>{`Optional Stuff`}</h1>
      <Steps mdxType="Steps">
        <ul>
          <li parentName="ul">{`Gitmoji`}</li>
          <li parentName="ul">{`Gitlens`}</li>
        </ul>
      </Steps>
    </Box>
    <hr></hr>
    <h2>{`So how exactly does Git work?`}</h2>
    <Steps mdxType="Steps">
      <Text sx={{
        color: 'red',
        textShadow: '0 0 12px currentColor',
        fontSize: 100,
        fontWeight: 'bold'
      }} mdxType="Text">Working Directory</Text>
      <Text sx={{
        color: 'yellow',
        textShadow: '0 0 12px currentColor',
        fontSize: 100,
        fontWeight: 'bold'
      }} mdxType="Text">Staging Area</Text>
      <Text sx={{
        color: 'blue',
        textShadow: '0 0 12px currentColor',
        fontSize: 100,
        fontWeight: 'bold'
      }} mdxType="Text">Repository</Text>
    </Steps>
    <hr></hr>
    <h1>{`now, lets try using Github and `}<inlineCode parentName="h1">{`git`}</inlineCode></h1>
    <h1><a parentName="h1" {...{
        "href": "https://github.com"
      }}>{`https://github.com`}</a></h1>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;